import Logger from '../lib/logger';

class AddToCartObserver extends HTMLElement {
  #NAME = 'AddToCartObserver'
  #abortController
  #buyBtns
  #intersector
  #observer
  #template
  #mobileBtnWrap

  constructor() {
    super();
    Logger.info(`${this.#NAME} > constructor`);
  }

  connectedCallback() {
    Logger.info(`${this.#NAME} > connectedCallback`);
    this.#abortController = new AbortController();
    const { signal } = this.#abortController;
    this.#mobileBtnWrap = document.querySelector('[data-mobile-add-to-cart-wrap]');
    //
    window.addEventListener('resize', () => this.#onResize(), { signal });
    this.#onResize();
  }

  disconnectedCallback() {
    this.#abortController.abort();
    this.#abortController = null;
    if (this.#observer) {
      this.#observer.disconnect();
      this.#observer = null
    }
  }

  static get observedAttributes() {
    return ['template'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    Logger.info(`${this.#NAME} > attributeChangedCallback > ${name}, ${oldValue}, ${newValue}`);
    if (name === 'template') {
      this.#template = newValue;
    }
  }

  #onResize() {
    Logger.info(`${this.#NAME} > #onResize > ${this.#template}`);
    if (this.#template === 'product.procion' || this.#template === 'product.procion-like') {
      this.#observeThis();
    } else {
      this.#observerIntersector();
    }
  }

  #observeThis() {
    Logger.info(`${this.#NAME} > #observeThis > ${this.#template}`);
    //
    if (window.innerWidth < 720 && !this.#observer) {
      this.#observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          this.#handleIntersecting(entry);
        })
      });
      this.#observer.observe(this);
    } else if (this.#observer) {
      this.#observer.disconnect();
      this.#observer = null;
    }
  }

  #observerIntersector() {
    Logger.info(`${this.#NAME} > #observerIntersector > ${this.#template}`);
    if (!this.#buyBtns) {
      this.#buyBtns = this.querySelector('block-buy-buttons');
      this.#intersector = document.querySelector('main .shopify-section:nth-child(2)');
    }
    //
    if (this.#buyBtns && window.innerWidth < 720 && !this.#observer) {
      this.#observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.target === this.#intersector) {
            if (entry.isIntersecting && entry.intersectionRatio > 0.02 && this.#buyBtns.dataset.sticking === 'true') {
              this.#buyBtns.dataset.sticking = 'false';
            } else if (!entry.isIntersecting || (entry.intersectionRatio < 0.02 && this.#buyBtns.dataset.sticking === 'false')) {
              this.#buyBtns.dataset.sticking = 'true';
            }
          } else if (entry.target === this.#buyBtns) {
            this.#handleIntersecting(entry);
          }
          
        })
      }, { threshold: [ 0.05, 0.2, 0.3, 0.5, 0.6, 0.7, 0.8, 0.9, 1 ]});
      this.#observer.observe(this.#intersector);
      this.#observer.observe(this.#buyBtns);
    } else if (this.#observer) {
      this.#observer.disconnect();
      this.#observer = null;
    }
  }

  #handleIntersecting(entry) {
    Logger.info(`${this.#NAME} > #handleBtnEntry > isIntersecting: ${entry.isIntersecting}`);
    if (entry.isIntersecting) {
      if (this.#mobileBtnWrap.dataset.show !== 'false') this.#mobileBtnWrap.dataset.show = 'false';
    } else if (entry.target.getBoundingClientRect().top <= 0) {
      if (this.#mobileBtnWrap.dataset.show !== 'true') this.#mobileBtnWrap.dataset.show = 'true';
    }
  }

}

customElements.define('add-to-cart-observer', AddToCartObserver);